// Remove fill-only settings without deleting settings shared with satin.
// max_stitch_length_mm controls satin splitting and must survive cleanup.
export function cleanSatinElement(el) {
  for (const name of [
    "fill_method", "row_spacing_mm", "staggers", "expand_mm",
    "randomize_stitch_length", "running_stitch_length_mm",
  ]) {
    delete el.attributes[`inkstitch:${name}`];
  }
}
